/* The tiebreaker prompt, rendered but inert.
 *
 * The pool's method (`last_game_total`) has requires_prediction = true and the
 * rules panel describes it, but nothing in the app writes
 * tiebreaker_predictions yet. Showing the prompt greyed out is the honest
 * middle: members can see what will be asked of them without being asked for
 * it, and without a live-looking box that silently discards what they type.
 *
 * DELIBERATELY OUTSIDE COMPLETION. This is not wired into pickedCount, total or
 * allIn in PicksPage, and it must not be. A member who has made every pick is
 * finished this week — a placeholder for unbuilt functionality holding back
 * "All in" would be a bug that reads as a rule.
 *
 * The input is `disabled` rather than `readOnly`: disabled controls are removed
 * from the tab order and refuse pointer input on their own, so the non-
 * interactivity is the element's real state, not styling that a keyboard user
 * could walk straight past.
 */
export default function TiebreakerPlaceholder({ label }: { label: string }) {
  return (
    <section className="bg-card border-rule rounded-row mt-6 border border-dashed px-4 py-3.5">
      <label
        htmlFor="tiebreaker-placeholder"
        className="text-ink-dim block font-mono text-eyebrow tracking-[0.16em] uppercase"
      >
        {label}
      </label>

      {/* Full-width and stacked, not label-beside-field: at 380px a two-column
          row would either wrap mid-label or squeeze the box to a few digits. */}
      <input
        id="tiebreaker-placeholder"
        type="text"
        inputMode="numeric"
        disabled
        placeholder="—"
        className="border-rule text-ink-dim rounded-row mt-2 w-full cursor-not-allowed border bg-transparent px-3 py-2.5 font-mono text-team tabular-nums"
      />

      <p className="text-ink-dim mt-2 text-body">
        Opens for the regular season — this week scores on picks alone.
      </p>
    </section>
  )
}
